import { useContext } from "react";
import { AuthContext } from "../../../Context/AuthContext";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";

export const useSendUpdateEmailOTP = () => {
  const { userType } = useContext(AuthContext);
  const navigate = useNavigate();

  const sendUpdateEmailOTP = async ({ oldEmail, newEmail }) => {
    let endpoint = "";
    if (userType === "Charterer") {
      endpoint = `${process.env.REACT_APP_SERVER_URL}/auth/sendUpdateEmailOTP/charterer`;
    } else if (userType === "Vessel Owner") {
      endpoint = `${process.env.REACT_APP_SERVER_URL}/auth/sendUpdateEmailOTP/vesselOwner`;
    } else {
      throw new Error("User type is invalid or missing.");
    }

    try {
      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ oldEmail, newEmail }),
      });

      if (!response.ok) {
        const errorResponse = await response.json();
        throw new Error(errorResponse.message || "Failed to send OTP.");
      }

      const data = await response.json();
      return data;
    } catch (error) {
      throw new Error(error.message);
    }
  };

  return useMutation(sendUpdateEmailOTP, {
    onSuccess: () => {
      navigate("/check_confirmation");
    },
  });
};
